import { PDFDocument } from 'pdf-lib';
import { useState } from 'react';

export const useMergePdf = () => {
  const [loading, setLoading] = useState(false);

  async function mergePdf(pdfs) {
    setLoading(true);

    try {
      const pdfDoc = await PDFDocument.create();

      for (const pdfUrl of pdfs) {
        const existingPdfBytes = await fetch(pdfUrl).then((res) => res.arrayBuffer());
        const existingPdfDoc = await PDFDocument.load(existingPdfBytes);
        const copiedPages = await pdfDoc.copyPages(existingPdfDoc, existingPdfDoc.getPageIndices());
        copiedPages.forEach((page) => pdfDoc.addPage(page));
      }

      const combinedPdfBytes = await pdfDoc.save();

      const blob = new Blob([combinedPdfBytes], { type: 'application/pdf' });

      const combinedPdfUrl = URL.createObjectURL(blob);

      window.open(combinedPdfUrl);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  }

  return { mergePdf, loading };
};
